export default class SettingEdapController {
	constructor($scope, SettingPortailService) {
		this.$scope = $scope;
		this.SettingPortailService = SettingPortailService;
	}
	$onInit() {}
	$onDestroy() {}
}

SettingEdapController.$inject = ['$scope', 'SettingPortailService'];
